import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ApartmentIcon from "@mui/icons-material/Apartment";
import CreateIcon from "@mui/icons-material/Create";
import { createTheme } from "@material-ui/core/styles";
import * as colors from "@material-ui/core/colors";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

const typography = {
  fontFamily: [
    "Noto Sans JP",
    "Lato",
    "游ゴシック Medium",
    "游ゴシック体",
    "Yu Gothic Medium",
    "YuGothic",
    "ヒラギノ角ゴ ProN",
    "Hiragino Kaku Gothic ProN",
    "メイリオ",
    "Meiryo",
    "ＭＳ Ｐゴシック",
    "MS PGothic",
    "sans-serif",
  ].join(","),
};

const GenericTemplateFireEquipment = ({ selectedIndex, number }) => {
  const buildingName = useSelector(
    (state) => state["FireEquipment"][`B${number}`]["f9"]["f92_1"]
  );

  const CheackInvestFireDoor = useSelector(
    (state) => state["FireEquipment"][`B${number}`]["f2"]["f25_ro1_1"]
  );
  const CheackInvestFireShutter = useSelector(
    (state) => state["FireEquipment"][`B${number}`]["f2"]["f25_ro2_1"]
  );
  const CheackInvestFireProtectionCrossScreen = useSelector(
    (state) => state["FireEquipment"][`B${number}`]["f2"]["f25_ro3_1"]
  );
  const CheackInvestDrencher = useSelector(
    (state) => state["FireEquipment"][`B${number}`]["f2"]["f25_ro4_1"]
  );

  const theme = createTheme({
    typography,
    palette: {
      primary: { main: colors.brown[300] }, // テーマの色
    },
  });

  const useStyles = makeStyles(() =>
    createStyles({
      link: {
        textDecoration: "none",
        color: theme.palette.text.secondary,
      },
      Annex_building: {
        paddingLeft: "15px",
      },
    })
  );

  const classes = useStyles();

  return (
    <>
      <Link to={`/f2/f2/B${number}`} className={classes.link}>
        <ListItem button>
          <ListItemIcon>
            <ApartmentIcon style={{ color: "rgb(161,136,127)" }} />
          </ListItemIcon>
          <ListItemText primary={`第${number}棟 ${buildingName}`} />
        </ListItem>
      </Link>
      <Link to={`/f2/f2/B${number}`} className={classes.link}>
        <ListItem button selected={selectedIndex === `/f2/f2/B${number}`}>
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary="第二面" />
        </ListItem>
      </Link>
      {CheackInvestFireDoor && (
        <Link to={`/finvestfiredoor/f41/B${number}`} className={classes.link}>
          <ListItem
            button
            selected={selectedIndex === `/finvestfiredoor/f41/B${number}`}
          >
            <ListItemIcon>
              <CreateIcon />
            </ListItemIcon>
            <ListItemText primary="検査結果表" secondary={"(防火扉)"} />
          </ListItem>
        </Link>
      )}
      {CheackInvestFireShutter && (
        <Link
          to={`/finvestfireshutter/f42/B${number}`}
          className={classes.link}
        >
          <ListItem
            button
            selected={selectedIndex === `/finvestfireshutter/f42/B${number}`}
          >
            <ListItemIcon>
              <CreateIcon />
            </ListItemIcon>
            <ListItemText primary="検査結果表" secondary={"(防火シャッター)"} />
          </ListItem>
        </Link>
      )}
      {CheackInvestFireProtectionCrossScreen && (
        <Link
          to={`/finvestfireprotectioncrossscreen/f43/B${number}`}
          className={classes.link}
        >
          <ListItem
            button
            selected={
              selectedIndex ===
              `/finvestfireprotectioncrossscreen/f43/B${number}`
            }
          >
            <ListItemIcon>
              <CreateIcon />
            </ListItemIcon>
            <ListItemText
              primary="検査結果表"
              secondary={"(耐火クロススクリーン)"}
            />
          </ListItem>
        </Link>
      )}
      {CheackInvestDrencher && (
        <Link to={`/finvestdrencher/f44/B${number}`} className={classes.link}>
          <ListItem
            button
            selected={selectedIndex === `/finvestdrencher/f44/B${number}`}
          >
            <ListItemIcon>
              <CreateIcon />
            </ListItemIcon>
            <ListItemText primary="検査結果表" secondary={`(ドレンチャー)`} />
          </ListItem>
        </Link>
      )}
    </>
  );
};

export default React.memo(GenericTemplateFireEquipment);
